import script from "./ReceiptDocument.vue?vue&type=script&setup=true&lang=js"
export * from "./ReceiptDocument.vue?vue&type=script&setup=true&lang=js"

import "./ReceiptDocument.vue?vue&type=style&index=0&id=772fde10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-772fde10"]])

export default __exports__